import React from "react";
import FileUpload from "./FileUpload";
import { formatFileSize } from "../utils/formatters";

interface FileData {
  filename: string;
  content: string;
  size: number;
  type: string;
}

interface ChatInputProps {
  inputMessage: string;
  setInputMessage: (value: string) => void;
  selectedFiles: FileData[];
  onFilesSelected: (files: FileData[]) => void;
  onRemoveFile: (index: number) => void;
  onSendMessage: () => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  isLoading: boolean;
  textareaRef: React.RefObject<HTMLTextAreaElement | null>;
}

const ChatInput: React.FC<ChatInputProps> = ({
  inputMessage,
  setInputMessage,
  selectedFiles,
  onFilesSelected,
  onRemoveFile,
  onSendMessage,
  onKeyPress,
  isLoading,
  textareaRef,
}) => {
  return (
    <div className="chat-input-container">
      {selectedFiles.length > 0 && (
        <div className="selected-files">
          {selectedFiles.map((file, index) => (
            <div key={index} className="selected-file">
              <span className="file-info">
                📎 {file.filename} ({formatFileSize(file.size)})
              </span>
              <button
                onClick={() => onRemoveFile(index)}
                className="remove-file-button"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="input-area">
        <div className="text-input-container">
          <FileUpload
            onFilesSelected={onFilesSelected}
            disabled={isLoading}
          />
          <textarea
            ref={textareaRef}
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            onKeyPress={onKeyPress}
            placeholder="Type your message..."
            disabled={isLoading}
            rows={1}
            className="message-input"
          />
          <button
            onClick={onSendMessage}
            disabled={
              (!inputMessage.trim() && selectedFiles.length === 0) ||
              isLoading
            }
            className="send-button"
          >
            {isLoading ? "..." : "→"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatInput;
